import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'bspk-scrim',
  template: '',
  host: {
    'data-bspk': 'scrim',
    'aria-hidden': 'true',
    '[attr.data-bspk-owner]': 'owner() || null',
  },
  styles: `
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: var(--z-index-scrim);
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--background-scrim);
      animation-name: fade-in;
      animation-duration: 1s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;

      @keyframes fade-in {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  `,
  styleUrl: './scrim.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BspkScrim {
  readonly owner = input<string>();
  readonly click = output<MouseEvent>();
}
